module.exports = __webpack_public_path__ + "img/automated-reporting.f74d174d.png";